"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Popover = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = require("../util/classnames");
var react_prop_types_1 = require("../react-prop-types");
var vdl_prefix_1 = require("../util/vdl-prefix");
var _1 = require("../util/_");
var Popover = /** @class */function (_super) {
  __extends(Popover, _super);
  function Popover() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.handleClick = function (e) {
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
    };
    _this.renderTitle = function () {
      return react_1.default.createElement("div", {
        className: "popover-title"
      }, _this.props.title);
    };
    return _this;
  }
  Popover.prototype.render = function () {
    var _a;
    var customProps = _1.omit(this.props, Object.keys(Popover.propTypes).concat(['container']));
    var _b = this.props,
      id = _b.id,
      contentId = _b.contentId,
      title = _b.title,
      children = _b.children,
      ariaLive = _b.ariaLive,
      className = _b.className,
      positionLeft = _b.positionLeft,
      positionTop = _b.positionTop,
      arrowOffsetLeft = _b.arrowOffsetLeft,
      arrowOffsetTop = _b.arrowOffsetTop,
      placement = _b.placement,
      style = _b.style;
    var classes = (_a = {}, _a[vdl_prefix_1.vdlPrefix('popover')] = true, _a[placement] = true, _a);
    var popoverStyle = Object.assign({}, {
      'left': positionLeft,
      'top': positionTop,
      'display': 'block'
    }, style);
    var arrowStyle = {
      'left': arrowOffsetLeft,
      'top': arrowOffsetTop
    };
    return react_1.default.createElement("div", __assign({
      role: "tooltip"
    }, customProps, {
      id: id,
      className: classnames_1.classNames(className, classes),
      style: popoverStyle,
      title: undefined,
      onClick: this.handleClick
    }), react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('popover__container')
    }, react_1.default.createElement("div", {
      className: "arrow",
      style: arrowStyle
    }), title ? this.renderTitle() : null, react_1.default.createElement("div", {
      className: "popover-content",
      "aria-live": ariaLive,
      id: contentId
    }, children)));
  };
  Popover.propTypes = {
    ariaLive: prop_types_1.default.oneOf(['off', 'assertive', 'polite']),
    contentId: prop_types_1.default.string,
    id: react_prop_types_1.isRequiredForA11y(prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number])),
    placement: prop_types_1.default.oneOf(['top', 'right', 'bottom', 'left']),
    positionLeft: prop_types_1.default.number,
    positionTop: prop_types_1.default.number,
    arrowOffsetLeft: prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string]),
    arrowOffsetTop: prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string]),
    title: prop_types_1.default.node,
    className: prop_types_1.default.string,
    children: prop_types_1.default.node,
    style: prop_types_1.default.object
  };
  Popover.defaultProps = {
    placement: 'right'
  };
  return Popover;
}(react_1.default.PureComponent);
exports.Popover = Popover;